import "./style.scss";
import { getBookByID } from "services/user/bookService";
import { useState, useEffect, useContext } from "react";
import { Formatter } from "utils/formatter";
import { getProvinces } from "services/user/orderService";
import { getDistricts } from "services/user/orderService";
import { getWards } from "services/user/orderService";
import { addNewAddress } from "services/user/orderService";
import { getAllMyAddress } from "services/user/orderService";
import { IoIosCloseCircle } from "react-icons/io";
import { createCodOrder } from "services/user/orderService";
import { useLocation, useNavigate } from "react-router-dom";
import { removeItems } from "services/user/cartService";
import { CartContext } from "context/CartContext";
import { createPaymentLink } from "services/user/orderService";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { BsCashCoin } from "react-icons/bs";
import { PacmanLoader } from "react-spinners";
import {
  setDefaultAddressByID,
  updateShippingAddress,
  deleteAddress,
} from "services/user/userService";
import { MdQrCode2 } from "react-icons/md";
import Swal from "sweetalert2";

const ConfirmOrder = () => {
  const [books, setBooks] = useState([]);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");

  const [hasAddress, setHasAddress] = useState(false);
  const [showShippingForm, setShowShippingForm] = useState(false);

  const token = localStorage.getItem("token");

  const [allAddress, setAllAddress] = useState([]);
  // const [selectedAddressId, setDefaultAddressId] = useState(null);
  const [defaultAddress, setDefaultAddress] = useState(null); // Địa chỉ mặc định từ DB
  const [selectedAddress, setSelectedAddress] = useState(null); // Địa chỉ được chọn từ radio button
  const [shippingAddressID, setShippingAddressID] = useState(null);

  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedWardId, setSelectedWardId] = useState("");

  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedProvinceId, setSelectedProvinceId] = useState("");
  const [paymentMethodID, setPaymentMethodID] = useState(null);
  const [items, setItems] = useState([]); // Tạo state cho items

  const location = useLocation(); // Lấy thông tin state khi điều hướng
  const [formattedItems, setFormattedItems] = useState([]);
  const navigate = useNavigate();
  const [totalPrice, setTotalPrice] = useState(0);

  const { removeFromCart } = useContext(CartContext);
  const [isLoading, setIsLoading] = useState(false);

  const [isAddressFormVisible, setIsAddressFormVisible] = useState(false);
  const [formMode, setFormMode] = useState("");
  const [shippingFee, setShippingFee] = useState("");

  useEffect(() => {
    if (location.state && location.state.items) {
      setItems(location.state.items);
      const convertedItems = location.state.items.map((item) => ({
        bookID: item.id,
        quantity: parseInt(item.quantity, 10),
      }));
      setFormattedItems(convertedItems);
      // console.log("Formatted items:", convertedItems);
    }
  }, [location.state]);

  //lấy toàn bộ địa chỉ của user
  useEffect(() => {
    const fetchAllAddress = async () => {
      try {
        const response = await getAllMyAddress(token);
        const allAddress = response.data;
        console.log(allAddress);
        setAllAddress(allAddress);
        if (allAddress && allAddress.length > 0) {
          setHasAddress(true);
          const defaultAddr = allAddress.find((addr) => addr.default === true);
          console.log("Default Address:", defaultAddr);
          if (defaultAddr) {
            setDefaultAddress(defaultAddr);
            setSelectedAddress(defaultAddr);
            setShippingAddressID(defaultAddr.id);
            const shippingFee = defaultAddr.city === 'Đà Nẵng' ? 10000 : 30000;
            setShippingFee(shippingFee); // Update the shipping fee
          }
        } else {
          setHasAddress(false);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
        setHasAddress(false);
      }
    };

    fetchAllAddress();
  }, [token]);

  const handleAddAddress = () => {
    setFormMode("add"); // Chuyển sang chế độ thêm
    setSelectedAddress({
      receiver: "",
      phoneNumber: "",
      address: "",
      province: "",
      provinceId: "",
      district: "",
      districtId: "",
      ward: "",
      wardId: "",
    }); // Reset selectedAddress
    setSelectedProvinceId("");
    setSelectedDistrictId("");
    setSelectedWardId("");
    setIsAddressFormVisible(true); // Hiển thị form
  };
  const handleEditAddress = async () => {
     if (!selectedAddress) {
         alert("Vui lòng chọn một địa chỉ để chỉnh sửa.");
         return;
       }
       console.log("Before edit:", selectedAddress);
       // Tìm ID của tỉnh từ tên tỉnh
       const province = provinces.find(
         (prov) => prov.name.toLowerCase() === selectedAddress.city.toLowerCase()
       );
       console.log("id tỉnh", province.id);
       if (!province) {
         console.error(`Không tìm thấy tỉnh: ${selectedAddress.city}`);
       }
   
       // Gọi API để lấy danh sách quận/huyện của tỉnh
       let districtsByProvince = [];
       try {
         const response = await getDistricts(province.id);
         districtsByProvince = response.data;
         console.log("Danh sách quận/huyện:", districtsByProvince);
       } catch (error) {
         console.error("Lỗi khi lấy danh sách quận/huyện:", error);
         alert("Không thể lấy danh sách quận/huyện. Vui lòng thử lại sau.");
         return;
       }
   
       // Tìm quận/huyện từ tên quận/huyện trong địa chỉ đã chọn
       const district = districtsByProvince.find(
         (dist) =>
           dist.name.toLowerCase() === selectedAddress.district.toLowerCase()
       );
   
       console.log("id quận", district.id);
   
       if (!district) {
         console.error(`Không tìm thấy quận/huyện: ${selectedAddress.district}`);
         return;
       }
   
       // Tìm ID của phường/xã từ tên phường/xã
       let wardsByDistrict = [];
       try {
         const response = await getWards(district.id);
         wardsByDistrict = response.data;
         console.log("Danh sách phường/xã:", wardsByDistrict);
       } catch (error) {
         console.error("Lỗi khi lấy danh sách phường/xã:", error);
         alert("Không thể lấy danh sách phường/xã. Vui lòng thử lại sau.");
         return;
       }
   
       // Tìm phường/xã từ tên phường/xã trong địa chỉ đã chọn
       const ward = wardsByDistrict.find(
         (wrd) => wrd.name.toLowerCase() === selectedAddress.ward.toLowerCase()
       );
       console.log("id xã", ward.id);
       if (!ward) {
         console.error(`Không tìm thấy phường/xã: ${selectedAddress.ward}`);
       }
   
       // Cập nhật lại địa chỉ đã chọn với các ID tìm được
   
       setSelectedAddress((prev) => ({
         ...prev,
         provinceId: province ? province.id : "",
         districtId: district ? district.id : "",
         wardId: ward ? ward.id : "",
       }));
   
       setFormMode("edit");
   
       console.log("Selected address after edit:", selectedAddress);
   
       setIsAddressFormVisible(true);
  };

  const handleSetDefaultAddress = async (addressID) => {
    if (!addressID) {
      alert("Vui lòng chọn một địa chỉ!");
      return;
    }
    try {
      setIsLoading(true); // Bắt đầu loading
      await setDefaultAddressByID(addressID, token);
      Swal.fire({
        icon: "success",
        title: "Cập nhật địa chỉ mặc định thành công!",
        text: "Địa chỉ của bạn đã được lưu.",
        confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
      });
      const updatedAddresses = allAddress.map(
        (address) =>
          address.id === addressID
            ? { ...address, default: true } // Cập nhật địa chỉ được chọn làm mặc định
            : { ...address, default: false } // Đặt lại các địa chỉ khác thành không mặc định
      );
      setAllAddress(updatedAddresses); // Cập nhật lại danh sách địa chỉ
    } catch (error) {
      console.error("Lỗi khi đặt địa chỉ mặc định:", error);
      alert("Có lỗi xảy ra khi đặt địa chỉ mặc định.");
    } finally {
      setIsLoading(false); // Dừng loading
    }
  };
  //thêm địa chỉ mới
  const saveAddress = async () => {
    // Kiểm tra xem selectedAddress đã được đồng bộ đầy đủ hay chưa
    const { receiver, phoneNumber, address, province, district, ward } =
      selectedAddress || {};
    console.log("địa chỉ", selectedAddress);

    if (
      !receiver ||
      !phoneNumber ||
      !address ||
      !province ||
      !district ||
      !ward
    ) {
      alert("Vui lòng điền đầy đủ thông tin.");
      return;
    }

    try {
      setIsLoading(true);
      const isDefault = false;
      const response = await addNewAddress(
        token,
        receiver,
        phoneNumber,
        address,
        province,
        district,
        ward,
        isDefault
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Lưu địa chỉ thành công!",
          text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
        setAllAddress(response.data.data);
      } else {
        alert("Có lỗi xảy ra khi lưu địa chỉ.");
      }
    } catch (error) {
      console.error("Error saving address", error);
      alert("Có lỗi xảy ra khi lưu địa chỉ.");
    } finally {
      setIsLoading(false);
    }
  };

  //update address
  const updateAddress = async () => {
    const { id, receiver, phoneNumber, address, city, district, ward } =
      selectedAddress || {};
    console.log("địa chỉ update", selectedAddress);

    // if (
    //   !receiver ||
    //   !phoneNumber ||
    //   !address ||
    //   !province ||
    //   !district ||
    //   !ward
    // ) {
    //   alert("Vui lòng điền đầy đủ thông tin.");
    //   return;
    // }

    try {
      setIsLoading(true);
      const isDefault = false;
      const response = await updateShippingAddress(
        token,
        id,
        receiver,
        phoneNumber,
        address,
        city,
        district,
        ward
      );
      // console.log("HEHE", response);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Chỉnh sửa địa chỉ thành công!",
          text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
        setAllAddress(response.data.data);
      } else {
        alert("Có lỗi xảy ra khi lưu địa chỉ.");
      }
    } catch (error) {
      console.error("Error saving address", error);
      alert("Có lỗi xảy ra khi lưu địa chỉ.");
    } finally {
      setIsLoading(false);
    }
  };
  //xóa địa chỉ
  const handleDeleteAddress = async (addressID) => {
    const address = allAddress.find((addr) => addr.id === addressID);
    if (address.default === true) {
      Swal.fire({
        icon: "error",
        title: "Lỗi!",
        text: "Bạn không thể xóa địa chỉ mặc định.",
        confirmButtonColor: "#5e2e86",
      });
      return;
    }
    try {
      setIsLoading(true);
      const response = await deleteAddress(addressID, token);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Xóa địa chỉ thành công!",
          text: "Địa chỉ của bạn đã được xóa.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
        setAllAddress((prevAddresses) =>
          prevAddresses.filter((address) => address.id !== addressID)
        );
      }
    } catch (error) {
      console.log("Xóa địa chỉ thất bại:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // lấy thông tin chi tiết của từng sp từ mảng item
  useEffect(() => {
    const fetchBookDetails = async () => {
      try {
        const booksData = await Promise.all(
          items.map(async (item) => {
            const bookData = await getBookByID(item.id);
            return { ...bookData.data, quantity: item.quantity };
          })
        );
        setBooks(booksData);
        const total = booksData.reduce(
          (acc, book) => acc + book.discountedPrice * book.quantity,
          0
        );
        setTotalPrice(total); // Cập nhật tổng tiền vào state
      } catch (error) {
        console.error("Error fetching book details:", error);
      }
    };

    if (items.length > 0) {
      fetchBookDetails(); // Gọi API lấy thông tin chi tiết sản phẩm
    }
  }, [items]);

  // lấy danh sách tỉnh/thành
  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await getProvinces(); // Gọi API lấy danh sách tỉnh/thành
        console.log("Provinces data:", response.data); // Kiểm tra dữ liệu trả về từ API
        setProvinces(response.data); // Lưu dữ liệu vào state
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces(); // Gọi hàm fetchProvinces khi component được mount
  }, []);
  //lấy danh sách quận/huyện theo tỉnh
  useEffect(() => {
    if (selectedProvinceId) {
      const fetchDistrict = async () => {
        // console.log("Fetching districts for province:", selectedProvinceId);
        const data = await getDistricts(selectedProvinceId);
        // console.log("Districts data:", data);
        setDistricts(data.data);
        setWards([]); // Clear wards when province changes
      };
      fetchDistrict();
    }
  }, [selectedProvinceId]);
  //lấy danh sách phường/xã theo quận/huyện
  useEffect(() => {
    if (selectedDistrictId) {
      const fetchWards = async () => {
        const data = await getWards(selectedDistrictId);
        setWards(data.data);
      };
      fetchWards();
    }
  }, [selectedDistrictId]);
  //chọn shippingAddressID
  const handleAddressSelect = (id) => {
    const selectedAddr = allAddress.find((addr) => addr.id === id);
    if (selectedAddr) {
      setSelectedAddress(selectedAddr); // Cập nhật địa chỉ đã chọn
    }
    // console.log("shipping id" + id);
    setShippingAddressID(id);
    if (selectedAddr.city === "Đà Nẵng") {
      setShippingFee(10000);
    } else {
      setShippingFee(30000);
    }
  };
  //chọn PaymendMethod
  const handlePaymentMethodChange = (e) => {
    const selectedPaymentMethod = e.target.value;
    if (selectedPaymentMethod === "cash") {
      setPaymentMethodID(1); // Thanh toán tiền mặt
    } else if (selectedPaymentMethod === "vnpay") {
      setPaymentMethodID(2); // Thanh toán qua VNPAY
    }
    console.log("Selected payment method ID:", paymentMethodID);
  };

  const handleOrder = async () => {
    if (!paymentMethodID) {
      Swal.fire({
        icon: "error",
        title: "Lỗi!",
        text: "Vui lòng chọn phương thức thanh toán!",
        confirmButtonColor: "#5e2e86",
      });
      return;
    }
    if (!shippingAddressID) {
      Swal.fire({
        icon: "error",
        title: "Lỗi!",
        text: "Vui lòng chọn địa chỉ giao hàng!",
        confirmButtonColor: "#5e2e86",
      });
      return;
    }
    try {
      if (paymentMethodID === 1) {
        try {
          // console.log("phí", shippingFee);
          setIsLoading(true);
          const response = await createCodOrder(
            token,
            formattedItems,
            paymentMethodID,
            shippingAddressID,
            shippingFee
          );
          if (response.message === "Create order successfully!") {
            const orderID = response.data.orderID;
            navigate(`/order-success/${orderID}`);
          }
        } finally {
          setIsLoading(false);
        }
      } else if (paymentMethodID === 2) {
        try {
          console.log("phí", shippingFee);
          setIsLoading(true);
          const response2 = await createPaymentLink(
            token,
            formattedItems,
            paymentMethodID,
            shippingAddressID,
            shippingFee
          );
          localStorage.setItem("orderID", response2.data.orderID);
          console.log("Order payment online successfully:", response2);
          if (response2 && response2.data.checkoutUrl) {
            window.location.href = response2.data.checkoutUrl;
          } else {
            console.error("Checkout URL không tồn tại");
          }
        } finally {
          setIsLoading(false);
        }
      }
      // Kiểm tra source và xóa sản phẩm ra khỏi giỏ hàng nếu đến từ `cartItems`
      if (location.state.source === "CartItems") {
        const bookIDs = formattedItems.map((item) => item.bookID);
        await removeFromCart(bookIDs);
      }
    } catch (error) {
      console.error("Error creating order:", error);
      alert("Có lỗi xảy ra khi đặt hàng. Vui lòng thử lại.");
    }
  };


    useEffect(() => {
      if (selectedAddress?.provinceId) {
        const fetchDistrict = async () => {
          const data = await getDistricts(selectedAddress.provinceId);
          setDistricts(data.data);
  
          // Tự động tải wards nếu districtId đã có trong selectedAddress
          if (selectedAddress.districtId) {
            const wardsData = await getWards(selectedAddress.districtId);
            setWards(wardsData.data);
          }
        };
        fetchDistrict();
      }
    }, [selectedAddress?.provinceId]);
  
  // if (!book) {
  //   return <p>Đang tải thông tin sản phẩm...</p>;
  // }

  return (
    <div className="container mt-4">
      <div className="row confirm">
        {/* Phần bên trái chiếm 8/12 chiều rộng */}
        <div className="col-8 box boxConfirm" style={{ padding: "20px" }}>
          <div className="header-container">
            <h1>Đơn hàng của bạn</h1>
          </div>
          <div className="product-infor">
            Thông tin sản phẩm
            {books.length > 0 ? (
              books.map((book, index) => (
                <div className="product-container custom-product-container p-2 mb-2">
                  <div className="product-item custom-product-item">
                    <img
                      src={book.imageLink}
                      alt="Sản phẩm"
                      className="coverImage"
                     
                    />
                    <div >
                      <h6 className="tieude-sp">{book.title}</h6>
                    </div>
                    <span className="sluong">SL: {book.quantity}</span>
                  </div>
                  <span className="za ms-3">
                    Giá: {Formatter(book.discountedPrice)}
                  </span>
                </div>
              ))
            ) : (
              <p>Không có sản phẩm nào được chọn.</p>
            )}
          </div>

          <div className="shipping-info">
            Thông tin giao hàng
            {hasAddress ? (
              <div>
                <p className="custom-address">
                  <FaMapMarkerAlt className="icon-map" />
                  {selectedAddress
                    ? `Địa chỉ giao hàng: ${selectedAddress.receiver}, ${selectedAddress.phoneNumber}, ${selectedAddress.address}, ${selectedAddress.ward}, ${selectedAddress.district}, ${selectedAddress.city}`
                    : "Không có địa chỉ được chọn."}
                </p>
                <IoIosArrowDropdownCircle className="icon-map" />
                <a
                  href="#"
                  className="a-change-address"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowShippingForm(true);
                  }}
                >
                  Thay đổi địa chỉ
                </a>
              </div>
            ) : (
              <div>
                <p>
                  <FaMapMarkerAlt className="icon-map" />
                  {selectedAddress
                    ? `Địa chỉ giao hàng: ${selectedAddress.receiver}, ${selectedAddress.phoneNumber}, ${selectedAddress.address}, ${selectedAddress.ward}, ${selectedAddress.district}, ${selectedAddress.city}`
                    : "Không có địa chỉ được chọn."}
                </p>

                <IoIosArrowDropdownCircle className="icon-map" />
                <button
                  className="a-change-address"
                  onClick={() => setShowShippingForm(true)}
                >
                  Thêm địa chỉ mới
                </button>
              </div>
            )}
          </div>

          {showShippingForm && (
            <div className="modal-overlay">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    className="modal-close"
                    onClick={() => setShowShippingForm(false)}
                  >
                    <IoIosCloseCircle />
                  </button>
                </div>
                <div className="title-list-address">
                  {" "}
                  Danh sách địa chỉ giao hàng của bạn
                </div>

                <div className="chooseAddress-container">
        <div className="chooseAddress">
          {allAddress.map((address) => (
            <div key={address.id} className="address-item">
              <input
                className="form-check-input"
                type="radio"
                id={`address-${address.id}`}
                name="selectedAddress"
                value={address.id}
                checked={
                  selectedAddress
                    ? selectedAddress.id === address.id
                    : defaultAddress?.id === address.id
                }
                onChange={() => handleAddressSelect(address.id)}
              />
              <label
                htmlFor={`address-${address.id}`}
                className="address-label"
              >
                {`${address.receiver}, ${address.phoneNumber}, ${address.address}, ${address.ward}, ${address.district}, ${address.city}`}{" "}
                {address.default && (
                  <span className="default-badge">Mặc định</span>
                )}
              </label>
            </div>
          ))}
        </div>
      </div>

                {isAddressFormVisible && selectedAddress && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          className="modal-close"
                          onClick={() => setIsAddressFormVisible(false)}
                        >
                          <IoIosCloseCircle />
                        </button>
                      </div>
                      <h5 className="tieude">
                        {formMode === "add"
                          ? "Thêm địa chỉ mới"
                          : "Chỉnh sửa địa chỉ"}
                      </h5>

                      <div className="mb-3 d-flex justify-content-between align-items-center">
                        <label
                          htmlFor="name"
                          className="form-label label-width"
                        >
                          Tên:
                        </label>
                        <input
                          type="text"
                          className="form-control input-width"
                          id="name"
                          value={selectedAddress.receiver || ""}
                          onChange={(e) =>
                            setSelectedAddress({
                              ...selectedAddress,
                              receiver: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="mb-3 d-flex justify-content-between align-items-center">
                        <label
                          htmlFor="phone"
                          className="form-label label-width"
                        >
                          Số điện thoại:
                        </label>
                        <input
                          type="text"
                          className="form-control input-width"
                          id="phone"
                          value={selectedAddress.phoneNumber || ""}
                          onChange={(e) =>
                            setSelectedAddress({
                              ...selectedAddress,
                              phoneNumber: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="mb-3 d-flex justify-content-between align-items-center">
                        <label
                          htmlFor="province"
                          className="form-label label-width"
                        >
                          Tỉnh/Thành:
                        </label>
                       <select
                                           id="province"
                                           className="form-control input-width"
                                           value={selectedAddress.provinceId || ""}
                                           onChange={(e) => {
                                             const selectedId = e.target.value;
                                             const selectedProvince = provinces.find(
                                               (prov) => prov.id === selectedId
                                             );
                       
                                             // Cập nhật selectedAddress và xóa districtId, wardId khi tỉnh thay đổi
                                             setSelectedAddress({
                                               ...selectedAddress,
                                               province: selectedProvince?.name || "",
                                               provinceId: selectedId,
                                               districtId: "",
                                               wardId: "",
                                             });
                       
                                             setDistricts([]); // Clear districts
                                             setWards([]); // Clear wards
                                           }}
                                         >
                                           <option value="">Chọn tỉnh/thành</option>
                                           {provinces.map((province) => (
                                             <option key={province.id} value={province.id}>
                                               {province.name}
                                             </option>
                                           ))}
                                         </select>
                                       </div>
                       
                                       <div className="mb-3 d-flex justify-content-between align-items-center">
                                         <label htmlFor="district" className="form-label label-width">
                                           Quận/Huyện:
                                         </label>
                                         <select
                                           id="district"
                                           className="form-control input-width"
                                           value={selectedAddress.districtId || ""}
                                           onChange={(e) => {
                                             const selectedId = e.target.value;
                                             const selectedDistrict = districts.find(
                                               (district) => district.id === selectedId
                                             );
                       
                                             setSelectedAddress({
                                               ...selectedAddress,
                                               district: selectedDistrict?.name || "",
                                               districtId: selectedId,
                                               wardId: "", // Clear ward when district changes
                                             });
                       
                                             // Tải wards khi quận/huyện thay đổi
                                             const fetchWards = async () => {
                                               const wardsData = await getWards(selectedId);
                                               setWards(wardsData.data);
                                             };
                                             fetchWards();
                                           }}
                                           disabled={!selectedAddress.provinceId} // Disable nếu chưa chọn tỉnh
                                         >
                                           <option value="">Chọn quận/huyện</option>
                                           {districts.map((district) => (
                                             <option key={district.id} value={district.id}>
                                               {district.name}
                                             </option>
                                           ))}
                                         </select>
                                       </div>
                                       <div className="mb-3 d-flex justify-content-between align-items-center">
                                         <label htmlFor="ward" className="form-label label-width">
                                           Phường/Xã:
                                         </label>
                       
                                         <select
                                           id="ward"
                                           className="form-control input-width"
                                           value={selectedAddress.wardId || ""}
                                           onChange={(e) => {
                                             const selectedId = e.target.value;
                                             const selectedWard = wards.find(
                                               (ward) => ward.id === selectedId
                                             );
                       
                                             setSelectedAddress({
                                               ...selectedAddress,
                                               ward: selectedWard?.name || "",
                                               wardId: selectedId,
                                             });
                                           }}
                                           disabled={!selectedAddress.districtId} // Disable nếu chưa chọn quận/huyện
                                         >
                                           <option value="">Chọn phường/xã</option>
                                           {wards.map((ward) => (
                                             <option key={ward.id} value={ward.id}>
                                               {ward.name}
                                             </option>
                                           ))}
                                         </select>
                      </div>
                      <div className="mb-3 d-flex justify-content-between align-items-center">
                        <label
                          htmlFor="address"
                          className="form-label label-width"
                        >
                          Địa chỉ:
                        </label>
                        <input
                          type="text"
                          className="form-control input-width"
                          id="address"
                          value={selectedAddress?.address || ""} // Lấy địa chỉ từ selectedAddress
                          onChange={(e) =>
                            setSelectedAddress({
                              ...selectedAddress,
                              address: e.target.value,
                            })
                          }
                        />
                      </div>

                      <button
                        className="btn save-address"
                        onClick={() => {
                          if (formMode === "edit") {
                            updateAddress(selectedAddress); // Cập nhật địa chỉ
                          } else {
                            saveAddress(); // Lưu địa chỉ mới
                          }
                          setIsAddressFormVisible(false); // Đóng form
                        }}
                      >
                        {formMode === "add"
                          ? "Lưu địa chỉ mới"
                          : "Lưu thay đổi địa chỉ"}
                      </button>
                    </div>
                  </div>
                )}

                <div className="address-actions">
                  <button
                    className="btn btn-add"
                    onClick={() => {
                      setSelectedAddress(null); // Xóa dữ liệu địa chỉ
                      handleAddAddress();
                    }}
                  >
                    Thêm địa chỉ
                  </button>
                  <button
                    className="btn btn-edit"
                    onClick={() => {
                      if (selectedAddress) {
                        handleEditAddress();
                      } else {
                        alert("Vui lòng chọn địa chỉ để chỉnh sửa!");
                      }
                    }}
                  >
                    Chỉnh sửa địa chỉ
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => handleSetDefaultAddress(selectedAddress?.id)}
                  >
                    Đặt làm địa chỉ mặc định
                  </button>
                  <button
                    className="btn btn-delete"
                    onClick={() => handleDeleteAddress(selectedAddress?.id)}
                  >
                    Xóa địa chỉ
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="payment-info">
            Phương thức thanh toán
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="cashPayment"
                value="cash"
                onChange={handlePaymentMethodChange}
              />
              <label className="form-check-label" htmlFor="cashPayment">
                Thanh toán bằng tiền mặt <BsCashCoin className="btn-cash" />
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="vnpayPayment"
                value="vnpay"
                onChange={handlePaymentMethodChange}
              />
              <label className="form-check-label" htmlFor="vnpayPayment">
                Thanh toán trực tuyến{" "}
                <MdQrCode2
                  title="Thanh toán trực tuyến"
                  style={{ fontSize: "1.7rem", color: "#5e2e86" }}
                />
              </label>
            </div>
          </div>
        </div>

        {/* Phần bên phải chiếm 4/12 chiều rộng */}
        <div className="col-4 box boxOrder">
          <div>
            <div className="payment-container">
              <div className="roww">
                <span>Tạm tính</span>
                {Formatter(totalPrice)}
              </div>
              {/* <div className="roww">
                <span>Giảm giá</span>
                <span>0</span>
              </div> */}
              <div className="roww">
                <span>Phí vận chuyển</span>
                <span>{Formatter(shippingFee)}</span>
              </div>
              <div className="roww">
                <span>Mã giảm giá</span>
                <span>0</span>
              </div>
              <hr className="aaa" />
              <div className="roww">
                <span>Thành tiền</span>
                <span className="highlight-price">
                  {Formatter(totalPrice + shippingFee)}
                </span>
              </div>
              <button className="btn-buy" onClick={handleOrder}>
                Đặt hàng
              </button>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmOrder;
